import axios from "axios";

// Backend resolution. Production hosts (custom domain like bonker.it, or
// *.onrender.com) ALWAYS use the known Render backend, so the deployed site
// never depends on a build-time env var that may be stale/misconfigured.
// Only local dev and the Emergent preview use REACT_APP_BACKEND_URL.
const RENDER_BACKEND_URL = "https://bonker-api-ajm2.onrender.com";

function resolveBackendUrl(): string {
  if (typeof window !== "undefined") {
    const h = window.location.hostname;
    const isDevOrPreview =
      h === "localhost" ||
      h === "127.0.0.1" ||
      h.endsWith(".preview.emergentagent.com");
    if (!isDevOrPreview) return RENDER_BACKEND_URL;
  }
  return (process.env.REACT_APP_BACKEND_URL as string) || RENDER_BACKEND_URL;
}

// Strip any trailing slash so `${BACKEND_URL}/api/v1` and media paths never
// produce a double slash (`//`), which the backend rejects with 404.
const BACKEND_URL = resolveBackendUrl().replace(/\/+$/, "");
export const API = `${BACKEND_URL}/api/v1`;

export const api = axios.create({ baseURL: API });

/** Build an absolute URL for a media file stored as a relative path. */
export const mediaUrl = (u?: string | null): string => {
  if (!u) return "";
  return u.startsWith("http") ? u : `${BACKEND_URL}${u}`;
};

const TOKEN_KEY = "bonker_token";

export const tokenStore = {
  get: (): string | null => localStorage.getItem(TOKEN_KEY),
  set: (t: string) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};

api.interceptors.request.use((config) => {
  const token = tokenStore.get();
  if (token) {
    (config.headers as any) = config.headers ?? {};
    (config.headers as any).Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(detail: unknown): string {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e: any) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (typeof (detail as any).msg === "string") return (detail as any).msg;
  return String(detail);
}
